import {
  Component,
  ElementRef,
  inject,
  viewChild,
  ViewChild,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalsComponent } from 'src/app/common/modals/modals.component';
import { ModalsService } from 'src/app/services/Modals/modals.service';
import { ToastComponent } from 'src/app/common/toast/toast.component';
import { ToastService } from 'src/app/services/Toast/toast.service';
import { HeaderComponent } from 'src/app/common/templates/header/header.component';
import {
  SidebarComponent,
  SidebarLink,
} from '../../../common/internal-sidebar/internal-sidebar.component';
import { FooterComponent } from 'src/app/common/templates/footer/footer.component';
import { PreviewImageComponent } from 'src/app/common/preview-image/preview-image.component';
import { PreviewImageService } from 'src/app/services/Image-preview/preview-image-service.service';

@Component({
  selector: 'app-template',
  imports: [
    RouterOutlet,
    FooterComponent,
    ModalsComponent,
    ToastComponent,
    HeaderComponent,
    SidebarComponent,
    PreviewImageComponent,
  ],
  templateUrl: './template.component.html',
  styleUrl: './template.component.scss',
})
export class TemplateComponent {
  // injectables
  previewService = inject(PreviewImageService);

  // refs
  @ViewChild('modals', { static: true }) modalsComponent!: ModalsComponent;
  @ViewChild('toast', { static: true }) toastComponent!: ToastComponent;
  @ViewChild('sidebar', { static: true, read: ElementRef })
  sidebar!: ElementRef;
  preview = viewChild.required<PreviewImageComponent>('preview');

  // data
  navLinks!: SidebarLink[];

  constructor(
    private modals: ModalsService,
    private toast: ToastService,
  ) {}
  ngOnInit() {
    this.modals.bindComponent(this.modalsComponent);
    this.toast.bindComponent(this.toastComponent);
    this.previewService.bindComponent(this.preview());
    this.initSidebar();
  }
  initSidebar() {
    this.navLinks = [
      {
        name: 'Dashboard',
        icon: 'bi-house',
        url: '/fae',
      },
      {
        name: 'Quotation',
        icon: 'bi-tags',
        url: '/fae/quotation',
      },
      {
        name: 'Clients',
        icon: 'bi-people',
        url: '/fae/clients',
      },
      {
        name: 'Products',
        icon: 'bi-box',
        url: '/fae/products',
      },
            {
        name: 'Product Concerns',
        icon: 'bi-exclamation-square',
        url: '/fae/concerns',
      },
      {
        name: 'Inquiries',
        icon: 'bi-chat-left-text',
        url: '/fae/inquiries',
      },
      {
        name: 'Events',
        icon: 'bi-calendar-event',
        url: '/fae/events',
      },
      {
        name: 'FAQs',
        icon: 'bi-question-circle',
        url: '/fae/faq-manage',
      },
    ];
  }
  showSidebar() {
    this.sidebar?.nativeElement.focus();
  }
}
